<template>
  <div ref="recaptcha" />
</template>
<script>
import RecaptchaService from '@/modules/recaptcha/services/recaptcha.service';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WCInvisibleRecaptcha',
  props: {
    action: {
      type: String,
      required: false,
      default: 'other',
      validator: value =>
        ['register', 'authorization', 'contact_us', 'login', 'other'].includes(value),
    },
  },
  methods: {
    async execute() {
      const action = this.action;
      return RecaptchaService.execute(action);
    },
  },
});
</script>
